var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "dialog-container",
      attrs: { visible: _vm.dialogVisible, width: "800px", height: "600px" },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c(
                "button",
                {
                  staticClass: "custom-close-button",
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_c("i", { staticClass: "el-icon-close" })]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "swiper",
        { ref: "dialogSwiper", attrs: { options: _vm.dialogSwiperOptions2 } },
        _vm._l(_vm.srcList, function(item, key) {
          return _c("swiper-slide", { key: key }, [
            _c("div", { staticClass: "dialog-slider-image" }, [
              _c("img", { attrs: { src: item } })
            ])
          ])
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "dialog-navigation" }, [
        _c("div", {
          staticClass: "dialog-button-prev el-icon-arrow-left",
          attrs: { slot: "button-prev" },
          slot: "button-prev"
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "dialog-button-next el-icon-arrow-right",
          attrs: { slot: "button-next" },
          slot: "button-next"
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dbcf331a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbcf331a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vilocal/img-preview.vue
// module id = LhDT
// module chunks = 2